import { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Card, CardBody } from 'reactstrap'

import { getBuckets } from 'slices/csvUploaderSlice'
import { showSuccess } from 'slices/notificationSlice'

import { NavMenu, CustomButton } from 'components/common'

import { CsvAutoRecordsUploadDialog } from './CsvAutoRecordsUploadDialog'

export const CsvAutoRecordsUpload = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getBuckets())
  }, [dispatch])

  return (
    <NavMenu>
      <>
        <div className="m-3">
          <div className="d-flex align-items-center justify-content-between mb-3">
            <div className="d-flex align-items-center">
              <div className="font-x-large fw-bold">個人別作業実績数</div>
            </div>
            <div className="d-flex  ms-auto">
              <CustomButton className="me-2" outline onClick={() => setIsDialogOpen(true)}>
                作業実績アップロード
              </CustomButton>
            </div>
          </div>
          <Card className="mt-2">
            <CardBody className="p-4">
              <div className="mb-3">
                個人別作業実績数を一括でアップロードできる機能です。右上の「作業実績アップロード」より実行してください。
              </div>

              <div className="my-3">
                <div className="my-2 fw-bold font-middle">基本事項</div>
                <ul className="mb-3">
                  <li>この機能を利用するためには事前設定（有償）が必要になるため、営業担当者までご連絡ください。</li>
                  <li>
                    アップロードの対象となるのは、「作業管理」で実績入力方法が「自動アップロード」となっている作業のみです。この実績入力方法は、一度設定すると変更できません。
                  </li>
                  <li>
                    アップロードされた個人別作業実績数の取り消しは、原則できません。間違ってアップロードした場合は、営業担当者までご連絡ください。
                  </li>
                </ul>
              </div>

              <div className="my-3">
                <div className="my-2 fw-bold font-middle">データに関する主な注意事項</div>
                <ul className="mb-3">
                  <li>
                    個人別作業実績数データは、作成ルールに基づき作成をお願いします。詳細はヘルプ（ヘルプサイト）をご参照ください。
                  </li>
                  <li>対応している文字コードはSHIFT-JISのみです。</li>
                  <li>作成ルールは、CSVアップローダーで取り込むデータと同じとなります。</li>
                  <li>事前設定したデータフォーマットと異なるファイルのアップロードはできません。</li>
                  <li>
                    当日を含め、45営業日前までの個人別作業実績数のアップロードが可能です。それ以前の日付や将来日付のデータは反映されません。
                  </li>
                </ul>
              </div>

              <div className="mt-3">
                ※本機能の詳細仕様（対象作業、文字コード、取込可能期間、取消可否等）は、ヘルプ（ヘルプサイト）に準拠します。
              </div>
            </CardBody>
          </Card>
        </div>
        <CsvAutoRecordsUploadDialog
          isOpen={isDialogOpen}
          onSuccess={() => {
            setIsDialogOpen(false)
            dispatch(
              showSuccess({
                successMessage: '作業実績のアップロードに成功しました。反映までしばらく時間がかかる場合があります。',
              })
            )
          }}
          onCancel={() => setIsDialogOpen(false)}
        />
      </>
    </NavMenu>
  )
}
